import React from "react";
import Avatar from "../Avatar";

function getStatusColor(score) {
	if (score == null || score < 0) return "rgba(255,255,255,0.25)";
	if (score >= 75) return "#4ade80";
	if (score >= 60) return "#facc15";
	if (score >= 50) return "#F87B1B";
	return "#ef4444";
}

const ICONS = {
	message: (
		<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
		</svg>
	),
	note: (
		<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
			<polyline points="14 2 14 8 20 8" />
			<line x1="9" y1="13" x2="15" y2="13" />
			<line x1="9" y1="17" x2="13" y2="17" />
		</svg>
	),
	plan: (
		<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
			<line x1="16" y1="2" x2="16" y2="6" />
			<line x1="8" y1="2" x2="8" y2="6" />
			<line x1="3" y1="10" x2="21" y2="10" />
		</svg>
	),
};

export default function StudentListItem({
	student,
	score,
	isActive,
	onClick,
	onMessage,
	onNote,
	onPlan,
}) {
	const daysSince = score?.daysSinceLastTraining;
	const statusColor = getStatusColor(score?.regularityScore);
	const inactive = daysSince != null && daysSince > 7;

	const handleAction = (e, fn) => {
		e.stopPropagation();
		if (fn) fn(student);
	};

	return (
		<div
			className={`coach-student-item ${isActive ? "active" : ""} ${inactive ? "inactive" : ""}`}
			onClick={onClick}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					onClick();
				}
			}}
		>
			<div className="coach-student-item-avatar-wrap">
				<Avatar prenom={student.prenom} nom={student.nom} photo={student.photoProfil} size={36} />
				<span className="coach-student-item-status" style={{ background: statusColor }} />
			</div>
			<div className="coach-student-item-info">
				<div className="coach-student-item-name">
					{student.prenom} {student.nom}
				</div>
			</div>
			<div className="coach-student-item-actions">
				{onMessage && !student.isSelf && (
					<button
						className="coach-student-item-action"
						onClick={(e) => handleAction(e, onMessage)}
						title="Envoyer un message"
						aria-label="Envoyer un message"
					>
						{ICONS.message}
					</button>
				)}
				{onNote && !student.isSelf && (
					<button
						className="coach-student-item-action"
						onClick={(e) => handleAction(e, onNote)}
						title="Note"
						aria-label="Note"
					>
						{ICONS.note}
					</button>
				)}
				{onPlan && (
					<button
						className="coach-student-item-action"
						onClick={(e) => handleAction(e, onPlan)}
						title="Planifier"
						aria-label="Planifier"
					>
						{ICONS.plan}
					</button>
				)}
			</div>
		</div>
	);
}
